import { z } from 'zod';

export const TransitDuplicateDataSchema = z.object({
  transitId: z.string(),
  name: z
    .string()
    .min(1, { message: 'Required' })
    .regex(/^[a-zA-Z0-9-]*$/g, { message: 'Name is invalid' }),
});
export type TransitDuplicateData = z.infer<typeof TransitDuplicateDataSchema>;
